import { createReducer, createSelector, on } from '@ngrx/store';
import { SMART_DOCUMENT_UPLOAD_STEP, SmartDocumentUploadFileData } from 'src/app/shared/constants-and-enums/smart-document-upload-types';
import {
    InitSmartDocumentUpload,
    ResetSmartDocumentUpload,
    SmartDocumentUploadAddFile,
    SmartDocumentUploadFailure,
    SmartDocumentUploadSubmit,
    SmartDocumentUploadSuccess
} from '../actions/smart-document-upload.actions';
import { AppState } from '../store';

export interface SmartDocumentUploadState {
    step: SMART_DOCUMENT_UPLOAD_STEP;

    files: SmartDocumentUploadFileData[];

    loading: boolean;
    numberOfUploadedDocuments: number;
    apiCallError: boolean;
}

export const initialState: SmartDocumentUploadState = {
    step: undefined,

    files: [],

    loading: false,
    numberOfUploadedDocuments: undefined,
    apiCallError: undefined
};

export const smartDocumentUploadReducer = createReducer(
    initialState,
    on(ResetSmartDocumentUpload, () => ({ ...initialState })),
    on(InitSmartDocumentUpload, () => ({
        ...initialState,
        step: SMART_DOCUMENT_UPLOAD_STEP.UPLOAD_FILE_AND_CATEGORIZE
    })),

    on(SmartDocumentUploadAddFile, (state, { fileData }) => ({ ...state, files: [...state.files, fileData] })),

    on(SmartDocumentUploadSubmit, (state) => ({ ...state, loading: true, step: SMART_DOCUMENT_UPLOAD_STEP.RESULT })),
    on(SmartDocumentUploadSuccess, (state, { numberOfUploadedDocuments }) => ({
        ...state,
        loading: false,
        numberOfUploadedDocuments
    })),
    on(SmartDocumentUploadFailure, (state) => ({ ...state, loading: false, apiCallError: true }))
);

export const smartDocumentUploadState = (state: AppState) => state.smartDocumentUploadState;
export const smartDocumentUploadFiles = createSelector(smartDocumentUploadState, ({ files }) => files);

export const smartDocumentUploadCurrentStep = createSelector(smartDocumentUploadState, ({ step }) => step);
export const smartDocumentUploadIsInUploadStep = createSelector(
    smartDocumentUploadCurrentStep,
    (step) => step === SMART_DOCUMENT_UPLOAD_STEP.UPLOAD_FILE_AND_CATEGORIZE
);
export const smartDocumentUploadIsInResultStep = createSelector(
    smartDocumentUploadCurrentStep,
    (step) => step === SMART_DOCUMENT_UPLOAD_STEP.RESULT
);

export const smartDocumentUploadLoading = createSelector(smartDocumentUploadState, ({ loading }) => loading);
export const smartDocumentUploadNumberOfUploadedFiles = createSelector(
    smartDocumentUploadState,
    ({ numberOfUploadedDocuments }) => numberOfUploadedDocuments
);
export const smartDocumentUploadApiCallError = createSelector(smartDocumentUploadState, ({ apiCallError }) => apiCallError);
